import { useContext, useEffect, useRef, useState } from "react";
import { getTranslate } from "react-localize-redux";
import { useSelector } from "react-redux";

import { MainContext } from "@context";

const selectTranslate = (state) => ({
	translate: getTranslate(state.localize),
});

const useController = ({ onSelect, onClose, value }) => {
	const headerRef = useRef(null);
	const { translate } = useSelector(selectTranslate);
	const { state: contextState } = useContext(MainContext);

	const [open, setOpen] = useState(false);
	const [selectedItem, setSelectedItem] = useState(null);

	const handleSelect = (item) => {
		setOpen(false);
		onSelect?.(item);
		setSelectedItem(item);
	};

	const handleToggle = () => {
		setOpen((prev) => !prev);
	};

	useEffect(() => {
		const handleClick = (e) => {
			if (headerRef.current && !headerRef.current.contains(e.target)) {
				setOpen(false);
			}
		};

		document.addEventListener("mouseup", handleClick);

		onClose?.(open);

		return () => {
			document.removeEventListener("mouseup", handleClick);
		};
	}, [open]);

	useEffect(() => {
		if (!value) {
			setSelectedItem(null);
		}
	}, [value]);

	return {
		refs: { headerRef },
		helpers: { translate },
		state: {
			...contextState,
			open,
			selectedItem,
		},
		handlers: {
			handleSelect,
			handleToggle,
		},
	};
};

export default useController;
